import React from "react"
import PropTypes from "prop-types"

import NumberText from "@components/NumberText"
import SVGHeader from "@components/SVGHeader"

const NumberTextModule = ({ title, numbers, extraClasses = {} }) => {
  return (
    <div
      className={
        extraClasses.container
          ? extraClasses.container
          : "py-8 px-6 md:py-10 xl:pt-[115px] desk:px-[100px] xl:pb-25 bg-lblue"
      }
    >
      <div
        className={
          extraClasses.svgContainer ? extraClasses.svgContainer : "mb-8 md:mb-4"
        }
      >
        <SVGHeader text={title} />
      </div>
      <div className="mx-auto max-w-screen-fhd">
        <ul
          className="flex flex-col md:flex-row gap-6 md:gap-4 xl:gap-12.5 
      md:justify-center md:px-5 xl:px-0 fhd:px-12.5"
        >
          {numbers.map(num => (
            <li key={num.number} className="flex flex-1">
              <NumberText {...num} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

NumberTextModule.propTypes = {
  title: PropTypes.string,
  numbers: PropTypes.array,
}

export default NumberTextModule
